import React from 'react';
import { FormShell, FormBody, FormHeader, FormTitle, FormSubtitle } from './FormLayout';
import { FormActions } from './FormActions';

interface FormProps {
  onSubmit: (e: React.FormEvent) => void;
  title?: string;
  subtitle?: string;
  compact?: boolean;
  embedded?: boolean;
  /** Hide the entire form header (title + subtitle). Useful when a parent modal already shows the title. */
  hideHeader?: boolean;
  /** Hide only the title — keeps subtitle visible as helper text below the modal header. */
  hideTitle?: boolean;
  /** Hide only the subtitle. */
  hideSubtitle?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  onCancel?: () => void;
  isLoading?: boolean;
  disableSubmit?: boolean;
  hideActions?: boolean;
  hideCancel?: boolean;
  children: React.ReactNode;
}

export const Form: React.FC<FormProps> = ({
  onSubmit,
  title,
  subtitle,
  compact,
  embedded,
  hideHeader,
  hideTitle,
  hideSubtitle,
  submitLabel,
  cancelLabel,
  onCancel,
  isLoading,
  disableSubmit,
  hideActions,
  hideCancel,
  children,
}) => {
  const showTitle = Boolean(title) && !hideHeader && !hideTitle;
  const showSubtitle = Boolean(subtitle) && !hideHeader && !hideSubtitle;

  return (
  <FormShell $compact={compact} $embedded={embedded}>
    <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
      {(showTitle || showSubtitle) && (
        <FormHeader $subtitleOnly={!showTitle && showSubtitle}>
          {showTitle && <FormTitle>{title}</FormTitle>}
          {showSubtitle && <FormSubtitle>{subtitle}</FormSubtitle>}
        </FormHeader>
      )}
      <FormBody>{children}</FormBody>
      {!hideActions && (
        <FormActions
          submitLabel={submitLabel}
          cancelLabel={cancelLabel}
          onCancel={onCancel}
          isLoading={isLoading}
          disabled={disableSubmit}
          hideCancel={hideCancel}
        />
      )}
    </form>
  </FormShell>
  );
};
